import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//actions:
import { getData, createReport } from '../dataLib';
import { openDialog, hideDialog } from '../actions/index';
import { setCentroDia } from '../actions/centro_dia_actions';

//components
import NeuriteGrid from '../components/neurite_grid';
import DatePicker from '../components/utils/DatePicker';

//#region CSS
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
//import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Button, Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
import Input from '@material-ui/core/Input';
import { enabledReport } from '../constants/utils';

const styles = theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    centroSelect: {
        maxWidth: 240,
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 10,
    },
    button: {
        margin: '15px 8px',
        padding: '10px',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        width: 150,
    },
    buttonCerrar: {
        padding: '10px',
        margin: '20px 8px 10px',
        width: 100,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: 250,
        height: 220,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    linearSpinner: {
        height: 10,
        width: 480,
        marginTop: 10,
        marginLeft: 10,
    },
    tooltip: {
        fontSize: 14,
        color: 'white',
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});
//#endregion

class ReportGeneric extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            report: {},
            values: {
                monthIni: new Date().getMonth() + 1,
                monthEnd: new Date().getMonth() + 1,
                yearIni: new Date().getFullYear(),
                yearEnd: new Date().getFullYear(),
                centroId:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.centro.id
                        : 1,
                iniDate:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.dia
                        : null,
                endDate:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.dia
                        : null,
                wIniDate:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.dia
                        : null,
                wEndDate:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.dia
                        : null,
                maquinaId: -100,
                modeloId: -100,
                chk1: false,
                chk2: false,
                chk3: false,
                chk4: false,
                chk5: false,
                opt1: '1',
                opt2: '1',
                dw: 1,
                ids: [0, 4, 5, 16, 17, 20].includes(this.props.userProfile.selectedCentroProfile.iPerfil) ? [] : [this.props.centroDiaSelected.centro.id],
                page: -1,
            },
            modelos: [],
            maquinas: [],
            regalos: [],
            datesToEnabled: [],
            datesToRender: [],
            loaded: false,
            pdfLoading: false,
            centroDiaCierre: 1,
        };
    }

    componentDidMount() {
        this.getReportDefinition();
        this.getModelos();
        this.getDcCierres();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.centros !== this.props.centros &&
            this.props.centros.length > 0
        ) {
            this.getMaquinas(this.props.centros[0].id);
        }
        if (prevProps.centroDiaSelected.centro.id !== this.props.centroDiaSelected.centro.id) {
            this.getDcCierres();
        }
    }

    //#region GetDATA
    getReportDefinition = () => {
        getData(
            'NaReport/' + this.props.reportId,
            response => {
                this.setState({
                    ...this.state,
                    report: response.data,
                    loaded: true,
                });
                if (response.data.maquina) {
                    if (response.data.iGroup !== 2)
                        this.getMaquinas(this.state.values.centroId);
                    else
                        this.getRegalos(this.state.values.centroId);
                }
                if (response.data.modelo) {
                    this.getModelos();
                }
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching report definition',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    compareDescr = (a, b) => {
        if (a.descr.toLowerCase() < b.descr.toLowerCase()) return -1;
        if (a.descr.toLowerCase() > b.descr.toLowerCase()) return 1;
        return 0;
    };

    getModelos = () => {
        getData(
            'VModeloMaquinas',
            response => {
                this.setState({
                    ...this.state,
                    modelos: [...response.data].sort(this.compareDescr),
                });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching modelos',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    getMaquinas = centroId => {
        //maquines del centro

        getData(
            'VMaquinas/VMaquinasAlta?centro_id=' + centroId,
            response => {
                this.setState({
                    ...this.state,
                    maquinas: [...response.data].sort(this.compareDescr),
                });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching maquinas',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    getRegalos = centroId => {
        //regalos del centro

        getData(
            'ArticuloCompraCentros/list/' + centroId,
            response => {
                this.setState({
                    ...this.state,
                    regalos: [...response.data].sort(this.compareDescr),
                });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching regalos',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    getDcCierres = () => {
        //REPORT resumen semanal
        if (this.props.reportId === 4 || this.props.reportId === 40 || this.props.reportId === 39) {
            getData(
                'DcCierre/' + this.props.centroDiaSelected.centro.id,
                response => {
                    let dates = response.data.map(d => { return new Date(d.fecha) });

                    this.setState({
                        ...this.state,
                        datesToRender: dates,
                        datesToEnabled: dates,
                    });
                },
                () => {
                    /* this.props.openDialog(
                        'SimpleMessage',
                        {
                            message: 'ERROR',
                        },
                        uuidv4(),
                        false,
                        'sm',
                    ); */
                },
                this.props.user,
            );
        }
        //REPORT inventarios
        if (this.props.reportId === 46) {
            getData(
                'DcInventarios/dates/' + this.props.centroDiaSelected.centro.id,
                response => {
                    let dates = response.data.map(d => { return new Date(d.fInventario) });
                    this.setState({
                        ...this.state,
                        datesToRender: dates,
                        datesToEnabled: dates,
                    });
                },
                () => {
                    /* this.props.openDialog(
                        'SimpleMessage',
                        {
                            message: 'ERROR',
                        },
                        uuidv4(),
                        false,
                        'sm',
                    ); */
                },
                this.props.user,
            );
        }
    }
    //#endregion

    //#region Handle
    handleValueChange = (event, field) => {
        const newValues = { ...this.state.values, [field]: event.target.value };
        this.setState({ ...this.state, values: newValues });
    };

    handleSelectCentrosValueChange = event => {
        var centroSelected = this.props.centros.find(
            c => c.id === Number(event.target.value),
        );
        if (centroSelected !== undefined) {
            const newValues = {
                ...this.state.values,
                centroId: event.target.value,
            };
            this.setState({
                ...this.state,
                values: newValues,
                centroDiaCierre: centroSelected.iDiaCierre,
            });
            if (this.state.report.maquina) {
                if (this.state.report.iGroup !== 2)
                    this.getMaquinas(event.target.value);
                else
                    this.getRegalos(event.target.value);
            }
            this.props.setCentroDia(
                centroSelected.id,
                this.props.centroDiaSelected.dia,
                false,
            );
        }
    };

    handleCheckboxChange = (event, field) => {
        const newValues = {
            ...this.state.values,
            [field]: event.target.checked,
        };
        this.setState({ ...this.state, values: newValues });
    };

    handleWIniDateValueChange = event => {
        const validWeekday = this.state.report.weekEnd
            ? this.state.centroDiaCierre + 1
            : this.state.centroDiaCierre;

        var dt = new Date(event);

        if (dt.getDay() !== validWeekday) return;

        const newValues = { ...this.state.values, wIniDate: event };
        this.setState({ ...this.state, values: newValues });
    };

    handleWEndDateValueChange = event => {
        var dt = new Date(event);
        if (dt.getDay() !== this.state.centroDiaCierre) return;

        const newValues = { ...this.state.values, wEndDate: event };
        this.setState({ ...this.state, values: newValues });
    };

    handleCentroSelection = (rows, centros) => {

        const newValues = {
            ...this.state.values,
            ids: rows.map(
                i => centros[i].id,
            ),
        };
        this.setState({ ...this.state, values: newValues });
    };

    handlePageValueChange = event => {
        const newValues = { ...this.state.values, page: event.target.value };
        this.setState({ ...this.state, values: newValues });
    };
    //#endregion

    //#region Displays
    renderIniDateTime = () => {
        if (this.state.report.dateIni) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <DatePicker
                        label={!this.state.report.dateEnd ? "Fecha final" : "Fecha inicial"}
                        value={this.state.values.iniDate}
                        className={classes.textField}
                        onChange={event => {
                            if (event && !isNaN(event)) {
                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                const newValues = {
                                    ...this.state.values,
                                    iniDate: d.toISOString().slice(0, 10),
                                };
                                this.setState({ ...this.state, values: newValues });
                            }
                        }}
                        datesToEnabled={this.state.datesToEnabled}
                        datesToRender={this.state.datesToRender}
                    />
                </FormControl>
            );
        }
    };

    renderEndDateTime = () => {
        if (this.state.report.dateEnd) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <DatePicker
                        label="Fecha final"
                        value={this.state.values.endDate}
                        className={classes.textField}
                        onChange={event => {
                            if (event && !isNaN(event)) {
                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                const newValues = {
                                    ...this.state.values,
                                    endDate: d.toISOString().slice(0, 10),
                                };
                                this.setState({ ...this.state, values: newValues });
                            }
                        }}
                        datesToEnabled={this.state.datesToEnabled}
                        datesToRender={this.state.datesToRender}
                    />
                </FormControl>
            );
        }
    };

    renderWeekIniDateTime = () => {

        if (this.state.report.weekIni) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <DatePicker
                        label={!this.state.report.weekEnd ? "Fecha semana final" : "Fecha semana inicial"}
                        value={this.state.values.wIniDate}
                        className={classes.textField}
                        onChange={event => {
                            if (event && !isNaN(event)) {
                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                this.handleWIniDateValueChange(d.toISOString().slice(0, 10))
                            }
                        }}
                        datesToEnabled={this.state.datesToEnabled}
                        datesToRender={this.state.datesToRender}
                    />
                </FormControl>
            );
        }
    };

    renderWeekEndDateTime = () => {
        if (this.state.report.weekEnd) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <DatePicker
                        label="Fecha semana final"
                        value={this.state.values.wEndDate}
                        className={classes.textField}
                        onChange={event => {
                            if (event && !isNaN(event)) {
                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                this.handleWEndDateValueChange(d.toISOString().slice(0, 10))
                            }
                        }}
                        datesToEnabled={this.state.datesToEnabled}
                        datesToRender={this.state.datesToRender}
                    />
                </FormControl>
            );
        }
    };

    renderCheckBox = field => {
        if (this.state.report[field]) {
            return (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={this.state.values[field]}
                            onChange={event =>
                                this.handleCheckboxChange(event, field)
                            }
                            color="primary"
                        />
                    }
                    label={this.state.report[field]}
                />
            );
        }
    };

    renderSelectCentros = () => {
        
        if ( this.props.kd ) return('');

        const perfil = this.props.userProfile.selectedCentroProfile.iPerfil;

        const centros = [0, 4, 5, 16, 17, 20].includes(perfil)
            ? this.props.centros.filter(c => c.activo === 1)
            : this.props.centros.filter(
                c =>
                    c.id ===
                    this.props.userProfile.selectedCentroProfile.centroId,
            );

        if (this.state.report.centroId) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="input-centros">Centro</InputLabel>
                    <Select
                        className={classes.centroSelect}
                        native
                        value={this.state.values.centroId}
                        onChange={event =>
                            this.handleSelectCentrosValueChange(event)
                        }
                        input={<Input id="input-centros" />}
                        name="centroId"
                    >
                        {centros.map(centro => {
                            return (
                                <option
                                    key={'centro_' + centro.id}
                                    value={centro.id}
                                >
                                    {centro.centro}
                                </option>
                            );
                        })}
                    </Select>
                </FormControl>
            );
        }
    };

    renderSelectMaquinas = () => {
        //maquines o regalos del centro
        if (this.state.report.maquina) {
            const { classes } = this.props;
            if (this.state.report.iGroup !== 2) {
                return (
                    <div>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="input-maquina">
                                Maquina
                            </InputLabel>
                            <Select
                                native
                                value={this.state.values.maquinaId}
                                onChange={event =>
                                    this.handleValueChange(event, 'maquinaId')
                                }
                                input={<Input id="input-maquina" />}
                                name="maquinaId"
                            >
                                <option key={'maquina_todos'} value={-100}>
                                    Todas
                                </option>
                                {this.state.maquinas.map(maquina => {
                                    return (
                                        <option
                                            key={'maquina_' + maquina.id}
                                            value={maquina.id}
                                        >
                                            {maquina.descr}
                                        </option>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </div>
                );
            } else {
                return (
                    <div>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="input-regalo">
                                Regalo
                            </InputLabel>
                            <Select
                                native
                                value={this.state.values.maquinaId}
                                onChange={event =>
                                    this.handleValueChange(event, 'maquinaId')
                                }
                                input={<Input id="input-regalo" />}
                                name="maquinaId"
                            >
                                <option key={'regalo_todos'} value={-100}>
                                    Todos
                                </option>
                                {this.state.regalos.map(regalo => {
                                    return (
                                        <option
                                            key={'maquina_' + regalo.id}
                                            value={regalo.id}
                                        >
                                            {regalo.descr}
                                        </option>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </div>
                );
            }
        }
    };

    renderSelectModelos = () => {
        if (this.state.report.modelo) {
            const { classes } = this.props;
            return (
                <div>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="input-modelo">Modelo</InputLabel>
                        <Select
                            native
                            value={this.state.values.modeloId}
                            onChange={event =>
                                this.handleValueChange(event, 'modeloId')
                            }
                            input={<Input id="input-modelo" />}
                            name="modeloId"
                        >
                            <option key={'modelo_todos'} value={-100}>
                                Todos
                            </option>
                            {this.state.modelos.map(modelo => {
                                return (
                                    <option
                                        key={'modelo_' + modelo.id}
                                        value={modelo.id}
                                    >
                                        {modelo.descr}
                                    </option>
                                );
                            })}
                        </Select>
                    </FormControl>
                </div>
            );
        }
    };

    renderOptionList1 = () => {
        return this.state.report.opt1.split(';').map((o, index) => {
            return (
                <FormControlLabel
                    key={index}
                    value={(index + 1).toString()}
                    control={<Radio />}
                    label={o}
                />
            );
        });
    };

    renderOptionList2 = () => {
        return this.state.report.opt2.split(';').map((o, index) => {
            return (
                <FormControlLabel
                    key={index}
                    value={(index + 1).toString()}
                    control={<Radio />}
                    label={o}
                />
            );
        });
    };

    renderOption1 = () => {
        if (
            this.state.report.opt1 !== undefined &&
            this.state.report.opt1 !== null
        ) {
            const { classes } = this.props;
            return (
                <FormControl
                    component="fieldset"
                    className={classes.formControl}
                    variant="outlined"
                >
                    <RadioGroup
                        aria-label="Option 1"
                        name="opt1"
                        className={classes.group}
                        value={this.state.values.opt1}
                        onChange={event =>
                            this.handleValueChange(event, 'opt1')
                        }
                    >
                        {this.renderOptionList1()}
                    </RadioGroup>
                </FormControl>
            );
        }
    };

    renderOption2 = () => {
        if (
            this.state.report.opt2 !== undefined &&
            this.state.report.opt2 !== null
        ) {
            const { classes } = this.props;
            return (
                <FormControl
                    component="fieldset"
                    className={classes.formControl}
                    variant="outlined"
                >
                    <RadioGroup
                        aria-label="Option 2"
                        name="opt2"
                        className={classes.group}
                        value={this.state.values.opt2}
                        onChange={event =>
                            this.handleValueChange(event, 'opt2')
                        }
                    >
                        {this.renderOptionList2()}
                    </RadioGroup>
                </FormControl>
            );
        }
    };

    renderSelectMonth = (field, label) => {
        if (this.state.report[field]) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <InputLabel>{!this.state.report.monthEnd ? 'Mes final' : label}</InputLabel>
                    <Select
                        value={this.state.values[field]}
                        onChange={event => this.handleValueChange(event, field)}
                        name={field}
                    >
                        <MenuItem key={field + '_month_1'} value={1}>
                            Enero
                        </MenuItem>
                        <MenuItem key={field + '_month_2'} value={2}>
                            Febrero
                        </MenuItem>
                        <MenuItem key={field + '_month_3'} value={3}>
                            Marzo
                        </MenuItem>
                        <MenuItem key={field + '_month_4'} value={4}>
                            Abril
                        </MenuItem>
                        <MenuItem key={field + '_month_5'} value={5}>
                            Mayo
                        </MenuItem>
                        <MenuItem key={field + '_month_6'} value={6}>
                            Junio
                        </MenuItem>
                        <MenuItem key={field + '_month_7'} value={7}>
                            Julio
                        </MenuItem>
                        <MenuItem key={field + '_month_8'} value={8}>
                            Agosto
                        </MenuItem>
                        <MenuItem key={field + '_month_9'} value={9}>
                            Septiembre
                        </MenuItem>
                        <MenuItem key={field + '_month_10'} value={10}>
                            Octubre
                        </MenuItem>
                        <MenuItem key={field + '_month_11'} value={11}>
                            Noviembre
                        </MenuItem>
                        <MenuItem key={field + '_month_12'} value={12}>
                            Diciembre
                        </MenuItem>
                        {this.state.report[field] === 2 ? (
                            <MenuItem key={field + '_month_13'} value={13}>
                                Todos
                            </MenuItem>
                        ) : (
                                ''
                            )}
                    </Select>
                </FormControl>
            );
        }
    };

    renderSelectYearIni = () => {
        if (this.state.report.yearIni) {
            const { classes } = this.props;
            let years = [];
            // if (this.state.report.iYearsFwd === 0) {
            //     for (var i = 2006; i <= new Date().getFullYear(); i++) {
            //         years.push(i);
            //     }
            // }
            // else {
            // for (var j = new Date().getFullYear(); j <= new Date().getFullYear() + parseInt(this.state.report.iYearsFwd); j++) {
            //     years.push(j);
            // }
            // }

            for (
                var i = 2006;
                i <=
                new Date().getFullYear() +
                parseInt(this.state.report.iYearsFwd);
                i++
            ) {
                years.push(i);
            }

            return (
                <FormControl className={classes.formControl}>
                    <InputLabel>{!this.state.report.yearEnd ? 'Año final' : 'Año inicial'}</InputLabel>
                    <Select
                        value={this.state.values.yearIni}
                        onChange={event =>
                            this.handleValueChange(event, 'yearIni')
                        }
                        name={'yearIni'}
                    >
                        {years.map(y => {
                            return (
                                <MenuItem key={'yearIni_year_' + y} value={y}>
                                    {y}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            );
        }
    };

    renderSelectYearEnd = () => {
        if (this.state.report.yearEnd) {
            const { classes } = this.props;
            let years = [];
            for (var i = 2006; i <= new Date().getFullYear(); i++) {
                years.push(parseInt(i));
            }
            return (
                <FormControl className={classes.formControl}>
                    <InputLabel>{'Año final'}</InputLabel>
                    <Select
                        value={this.state.values.yearEnd}
                        onChange={event =>
                            this.handleValueChange(event, 'yearEnd')
                        }
                        name={'yearEnd'}
                    >
                        {years.map(y => {
                            return (
                                <MenuItem key={'yearEnd_year_' + y} value={y}>
                                    {y}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            );
        }
    };

    renderSelectWeekDay = () => {
        if (this.state.report.dayofweek) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <InputLabel>{'Día de la semana'}</InputLabel>
                    <Select
                        value={this.state.values.dw}
                        onChange={event => this.handleValueChange(event, 'dw')}
                        name={'dw'}
                    >
                        <MenuItem key={'weekday_1'} value={1}>
                            Lunes
                        </MenuItem>
                        <MenuItem key={'weekday_2'} value={2}>
                            Martes
                        </MenuItem>
                        <MenuItem key={'weekday_3'} value={3}>
                            Miércoles
                        </MenuItem>
                        <MenuItem key={'weekday_4'} value={4}>
                            Jueves
                        </MenuItem>
                        <MenuItem key={'weekday_5'} value={5}>
                            Viernes
                        </MenuItem>
                        <MenuItem key={'weekday_6'} value={6}>
                            Sábado
                        </MenuItem>
                        <MenuItem key={'weekday_7'} value={7}>
                            Domingo
                        </MenuItem>
                        {this.state.report.dayofweek === 2 ? (
                            <MenuItem key={'weekday_8'} value={8}>
                                Todos
                            </MenuItem>
                        ) : (
                                ''
                            )}
                    </Select>
                </FormControl>
            );
        }
    };

    renderDates = () => {
        if (this.state.report.dateIni || this.state.report.dateEnd) {
            return (
                <Grid container spacing={10}>
                    <Grid item xs={6}>
                        {this.renderIniDateTime()}
                    </Grid>
                    <Grid item xs={6}>
                        {this.renderEndDateTime()}
                    </Grid>
                </Grid>
            );
        }
        else {
            return null;
        }
    };

    renderWDates = () => {
        if (this.state.report.weekIni || this.state.report.weekEnd) {
            return (
                <Grid container spacing={10}>
                    <Grid item xs={6}>
                        {this.renderWeekIniDateTime()}
                    </Grid>
                    <Grid item xs={6}>
                        {this.renderWeekEndDateTime()}
                    </Grid>
                </Grid>
            );
        } else {
            return null;
        }
    };

    renderSelectMonths = () => {

        return (
            <Grid container spacing={10}>
                <Grid item xs={6}>
                    {this.renderSelectMonth('monthIni', 'Mes inicial')}
                </Grid>
                <Grid item xs={6}>
                    {this.renderSelectMonth('monthEnd', 'Mes final')}
                </Grid>
            </Grid>
        );
    };

    renderSelectYears = () => {

        return (
            <Grid container spacing={10}>
                <Grid item xs={6}>
                    {this.renderSelectYearIni()}
                </Grid>
                <Grid item xs={6}>
                    {this.renderSelectYearEnd()}
                </Grid>
            </Grid>
        );
    };

    renderOptions = () => {
        return (
            <Grid container spacing={10}>
                <Grid item xs={6}>
                    {this.renderOption1()}
                </Grid>
                <Grid item xs={6}>
                    {this.renderOption2()}
                </Grid>
            </Grid>
        );
    };

    renderCentrosGrid = () => {
        const perfil = this.props.userProfile.selectedCentroProfile.iPerfil;
        let centros = [0, 4, 5, 16, 17, 20].includes(perfil)
            ? this.props.centros.filter(c => c.activo === 1)
            : [this.props.centros.find( //dejamos la lista de un elemento
                c =>
                    c.id ===
                    this.props.userProfile.selectedCentroProfile.centroId,
            )];

        centros = centros.filter(c => c.isGroup === false);

        if (this.props.hasIdList && this.props.reportId !== 34) {
            return (
                <NeuriteGrid
                    id="r_g"
                    columns={[
                        {
                            key: 'centro',
                            name: 'Centro',
                            editable: false,
                            dragable: false,
                            width: 300,
                        },
                    ]}
                    rows={centros}
                    height={300}
                    buttonEdit={false}
                    buttonDelete={false}
                    buttonNew={false}
                    enableSelection={centros.length === 1 ? false : true}
                    onSelection={(rows) => this.handleCentroSelection(rows, centros)}
                />
            );
        }
    };

    renderPagesOptions = files => {
        return files.map((file, index) => {
            return (
                <MenuItem key={index} value={index}>
                    {index + 1}
                </MenuItem>
            );
        });
    };

    renderPageSelector = () => {
        const files = this.state.report.reportFile.split('|');

        if (files.length > 1) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <InputLabel>{'Página'}</InputLabel>
                    <Select
                        value={this.state.values.page}
                        onChange={event => this.handlePageValueChange(event)}
                        name={'page'}
                    >
                        <MenuItem key={-1} value={-1}>
                            Todas
                        </MenuItem>
                        {this.renderPagesOptions(files)}
                    </Select>
                </FormControl>
            );
        }
    };
    //#endregion

    //#region OnClick
    auxMoreThan2Years(reportValues) {
        // Devuelve true si, o bien el report no contiene fechas, o si las contiene entonces el
        // periodo escogido es inferior a 2 años

        // O bien si es un "jefe"
        if(this.props.userProfile.profile.usuarioCentro.find(uc => [0,17,20].includes(uc.iPerfil) && uc.centroId === 10))
            return true;

        const fechaActual = new Date();
        var yr_min = fechaActual.getFullYear()-2;
        const f_min = fechaActual.setFullYear(yr_min);

        if ( reportValues.reportDefinition.yearIni === true && reportValues.values.yearIni < yr_min )
            return false;

        if (reportValues.reportDefinition.dateIni === true ) {
            const f_fini = new Date (reportValues.values.iniDate)
            if ( f_fini < f_min )
                return false;
        }

        if (reportValues.reportDefinition.weekIni === true ) {
            const f_fini = new Date (reportValues.values.wIniDate)
            if ( f_fini < f_min )
                return false;
        }

        return true;
    };

    viewPDF = reportValues => {

        if ( !this.auxMoreThan2Years(reportValues)){
            this.props.openDialog(
                'SimpleMessage',
                {
                    message: 'ERROR: cannot access this year',
                },
                uuidv4(),
                false,
                false,
            );
            return;
        }

        const suffix = this.props.hasIdList || this.props.reportId === 30? '/IdListReport' : '';

        if(this.props.reportId === 30){
            //añade los centros a los que tiene permiso
            if(this.props.userProfile.profile.usuarioCentro.find(uc => [0,17,20].includes(uc.iPerfil) && uc.centroId === 10))
            {
                reportValues.values.ids =[];
            }
            else{
                reportValues.values.ids = this.props.userProfile.profile.usuarioCentro.filter(uc => [14,15,18,19,20,0].includes(uc.iPerfil)).map(uc => uc.centroId);
            }

        }

        const win = window.open(
            process.env.PUBLIC_URL + '/loading_report.html',
            '_blank',
        );

        let url = '';

        createReport(reportValues, 'PDF', this.props.user, suffix, this.props.userProfile)
            .then(response => {
                url = window.URL.createObjectURL(
                    new Blob([response.data], { type: 'application/pdf' }),
                );
                //window.open(url, '_blank');
                win.location.href = url;
            })
            .catch(error => {
                console.log(error);
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF',
                    },
                    uuidv4(),
                    false,
                    false,
                );
            })
            .then(() => {
                this.setState({ ...this.state, pdfLoading: false });
            });
    };

    downloadPDF = reportValues => {

        if ( !this.auxMoreThan2Years(reportValues)){
            this.props.openDialog(
                'SimpleMessage',
                {
                    message: 'ERROR: cannot access this year',
                },
                uuidv4(),
                false,
                false,
            );
            return;
        }
        
        const suffix = this.props.hasIdList || this.props.reportId === 30? '/IdListReport' : '';

        if(this.props.reportId === 30){
            //añade los centros a los que tiene permiso
            if(this.props.userProfile.profile.usuarioCentro.find(uc => [0,17,20].includes(uc.iPerfil) && uc.centroId === 10))
            {
                reportValues.values.ids =[];
            }
            else{
                reportValues.values.ids = this.props.userProfile.profile.usuarioCentro.filter(uc => [14,15,18,19,20,0].includes(uc.iPerfil)).map(uc => uc.centroId);
            }

        }

        createReport(reportValues, 'PDF', this.props.user, suffix, this.props.userProfile)
            .then(response => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    'report_' +
                    reportValues.reportDefinition.descr.replace(
                        / /gi,
                        '_',
                    ) +
                    '.pdf',
                );
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF',
                    },
                    uuidv4(),
                    false,
                    false,
                );
            })
            .then(() => {
                this.setState({ ...this.state, pdfLoading: false });
            });
    };

    downloadExcel = reportValues => {

        if ( !this.auxMoreThan2Years(reportValues)){
            this.props.openDialog(
                'SimpleMessage',
                {
                    message: 'ERROR: cannot access this year',
                },
                uuidv4(),
                false,
                false,
            );
            return;
        }

        const suffix = this.props.hasIdList || this.props.reportId === 30? '/IdListReport' : '';
        
        if(this.props.reportId === 30){
            //añade los centros a los que tiene permiso
            if(this.props.userProfile.profile.usuarioCentro.find(uc => [0,17,20].includes(uc.iPerfil) && uc.centroId === 10))
            {
                reportValues.values.ids =[];
            }
            else{
                reportValues.values.ids = this.props.userProfile.profile.usuarioCentro.filter(uc => [14,15,18,19,20,0].includes(uc.iPerfil)).map(uc => uc.centroId);
            }

        }

        createReport(reportValues, 'EXCEL', this.props.user, suffix, this.props.userProfile)
            .then(response => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    'report_' +
                    reportValues.reportDefinition.descr.replace(
                        / /gi,
                        '_',
                    ) +
                    '.xls',
                );
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF',
                    },
                    uuidv4(),
                    false,
                    false,
                );
            })
            .then(() => {
                this.setState({ ...this.state, pdfLoading: false });
            });
    };
    //#endregion


    render() {
        const { classes } = this.props;
        //console.log(this.state, this.props);

        return (
            <div className={classes.root}>
                {this.state.loaded ? (
                    <div>
                        <div>
                            {this.props.isDialog ? (
                                <Typography
                                    variant="h6"
                                    style={{ margin: '10px 8px' }}
                                    color={'primary'}
                                >
                                    {this.state.report.descr}
                                </Typography>
                            ) : (
                                    ''
                                )}

                            {this.renderSelectCentros()}
                            {this.renderDates()}
                            {this.renderWDates()}
                            {this.renderSelectMonths()}
                            {this.renderSelectYears()}
                            {this.renderSelectWeekDay()}
                            {this.renderSelectMaquinas()}
                            {this.renderSelectModelos()}
                            {this.renderCheckBox('chk1')}
                            {this.renderCheckBox('chk2')}
                            {this.renderCheckBox('chk3')}
                            {this.renderCheckBox('chk4')}
                            {this.renderCheckBox('chk5')}
                            {this.renderOptions()}
                            {this.renderCentrosGrid()}
                            {this.renderPageSelector()}

                            <div>
                                <Tooltip
                                    title="Ver PDF (permite descarga posterior)"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 600 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        disabled={!enabledReport(this.state.values.iniDate, this.props)}
                                        onClick={() => {
                                            const reportValues = {
                                                reportDefinition: this.state
                                                    .report,
                                                values: this.state.values,
                                            };
                                            this.setState({
                                                ...this.state,
                                                pdfLoading: true,
                                            });
                                            this.viewPDF(reportValues);
                                        }}
                                    >
                                        Abrir PDF
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    title="Descarga pdf sin visualizar previamente"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 600 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        disabled={!enabledReport(this.state.values.iniDate, this.props)}
                                        onClick={() => {
                                            const reportValues = {
                                                reportDefinition: this.state
                                                    .report,
                                                values: this.state.values,
                                            };
                                            this.setState({
                                                ...this.state,
                                                pdfLoading: true,
                                            });
                                            this.downloadPDF(reportValues);
                                        }}
                                    >
                                        Descargar PDF
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    title="Vista rápida de datos en tabla"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 600 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        disabled={!enabledReport(this.state.values.iniDate, this.props)}
                                        onClick={() => {
                                            const reportValues = {
                                                reportDefinition: this.state
                                                    .report,
                                                values: this.state.values,
                                            };
                                            this.props.openDialog('ReportDataGrid', { reportValues: reportValues }, 'report-data-grid', false, 'lg');
                                        }}
                                    >
                                        Tabla rápida
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    title="Descarga en hoja excel"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 600 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        disabled={!enabledReport(this.state.values.iniDate, this.props)}
                                        onClick={() => {
                                            const reportValues = {
                                                reportDefinition: this.state
                                                    .report,
                                                values: this.state.values,
                                            };
                                            this.setState({
                                                ...this.state,
                                                pdfLoading: true,
                                            });
                                            this.downloadExcel(reportValues);
                                        }}
                                    >
                                        Descargar Excel
                                    </Button>
                                </Tooltip>
                            </div>
                        </div>
                        {this.state.pdfLoading ? (
                            <LinearProgress
                                className={classes.linearSpinner}
                                variant="indeterminate"
                            />
                        ) : (
                                ''
                            )}

                        {this.props.isDialog ? (
                            <Button
                                className={classes.buttonCerrar}
                                variant="contained"
                                color="secondary"
                                onClick={() => this.props.hideDialog()}
                            >
                                Cerrar
                            </Button>
                        ) : (
                                ''
                            )}
                    </div>
                ) : (
                        <div className={classes.spinnerContainer}>
                            <CircularProgress
                                className={classes.spinner}
                                color="primary"
                            />
                        </div>
                    )}
            </div>
        );
    }
}

ReportGeneric.propTypes = {
    //state:
    centroDiaSelected: PropTypes.object.isRequired,
    centros: PropTypes.array,
    user: PropTypes.object.isRequired,
    //dispatch:
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    //params:
    reportId: PropTypes.number.isRequired,
    hasIdList: PropTypes.bool,
};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        centros: state.centros.centros,
        user: state.oidc.user,
        userProfile: state.userProfile,
        kd : state.userProfile.kd,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            openDialog,
            hideDialog,
            setCentroDia,
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(ReportGeneric));
